import { Loader2, Inbox } from "lucide-react";
import { Card } from "@/components/ui/card";

export function Spinner({ className = "h-6 w-6" }) {
  return <Loader2 className={`animate-spin text-primary ${className}`} />;
}

export function SectionLoader({ label = "Loading…" }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-muted-foreground">
      <Spinner />
      <p className="text-sm">{label}</p>
    </div>
  );
}

export function EmptyState({ icon: Icon = Inbox, title, description, action, testId }) {
  return (
    <Card className="border-dashed bg-card p-10 text-center" data-testid={testId}>
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-secondary">
        <Icon className="h-6 w-6 text-muted-foreground" />
      </div>
      <h3 className="mt-4 font-serif text-lg font-semibold text-foreground">{title}</h3>
      {description && <p className="mx-auto mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>}
      {action && <div className="mt-5 flex justify-center">{action}</div>}
    </Card>
  );
}
